// Look back & date filtering constants (in days)
export const ALL_ALERTS_LOOK_BACK = 8000;
export const FIVE_YEARS = 5 * 365;
export const ONE_YEAR = 365;
export const SIX_MONTHS = 180;
export const ONE_MONTH = 30;
export const TXM_DEFAULT_LOOK_BACK = 365;
export const TXM_DEFAULT_LOOK_BACK_JP = 180;
